import { CommonPracticeCrumbs } from './practice-crubs';

export const SearchNotificationCrumbs = [
  ...CommonPracticeCrumbs,
  {
    name: 'Ricerca Comunicazioni SEND',
    path: '/pratiche/notifiche',
  },
];

export const DetailNotificationCrumbs = [
  ...SearchNotificationCrumbs,
  {
    name: 'Stato Avanzamento Notifica',
    path: '/pratiche/notifiche/dettaglio/:id',
  },
];
